/* eslint-disable @typescript-eslint/no-this-alias */
import { inject, Injectable } from '@angular/core';
import { delay, Observable, Subject } from 'rxjs';
import { RemicShelfService } from '../../remic-shelf/services/remic-shelf.service';
import { StringConstants } from '../constants/string-constants';

@Injectable({
  providedIn: 'root',
})
export class PricingFileUploadService {
  status = false;
  transactionPayload: any = {};
  requestId = '';

  datamain1: any = {};

  private fileUploadFailSource = new Subject<any>();
  public fileUploadFailSubscription$ = this.fileUploadFailSource.asObservable();

  private remicService = inject(RemicShelfService);

  public handleREMICUploadProcess(files): Observable<any> {
    if (files.length > 0) {
      return new Observable((observer) => {
        this.onFileUpload(files[0]).subscribe({
          next: (data) => {
            observer.next(data);
            observer.complete();
          },
          error: (_error) => {
            console.log('error from handleREMICUploadProcess');
          },
        });
      });
    }
  }

  public onFileUpload(fileInput: any): Observable<any> {
    const fi = fileInput;
    const self = this;
    if (fi && fi.name) {
      const fileName = fi.name;
      self.transactionPayload.fileName = fileName;
      const subFile = [];
      const fileToUpload = fi;
      const request: any = new Object();
      const subRequest: any = new Object();
      request.appCode = 'FJ5';
      subRequest.filename = fileName;
      subRequest.fileid = '0';
      subFile.push(subRequest);
      request.fileNames = subFile;

      return new Observable((observer) => {
        self.remicService.upfUploadLocation(request).subscribe({
          next: (data) => {
            self.callFileUpload(fileToUpload, data).subscribe(() => {
              observer.next(true);
              observer.complete();
            });
          },
          error: (error) => {
            console.log('error from onFileUpload');
            this.broadcastFileUploadFailUpdates(error);
          },
        });
      });
    }
  }

  public callFileUpload(fileInput: any, res: any): Observable<any> {
    const fi = fileInput;
    const self = this;
    if (fi.name) {
      const fileToUpload = fi;
      const url = res[0].url;
      self.requestId = res[0].uploadReferenceId;

      return new Observable((observer) => {
        self.remicService
          .upfUploadRemic(fileToUpload, null, url)
          .pipe(delay(1000))
          .subscribe({
            next: (data) => {
              self.handelUploadSuccess(data).subscribe(() => {
                observer.next(true);
                observer.complete();
              });
            },
            error: (error) => {
              console.log('error from callFileUpload');
              this.broadcastFileUploadFailUpdates(error);
            },
          });
      });
    }
  }

  public handelUploadSuccess(_data): Observable<any> {
    const that = this;

    return new Observable((observer) => {
      setTimeout(function () {
        that
          .callFileStatus()
          .pipe(delay(1000))
          .subscribe({
            next: () => {
              observer.next(true);
              observer.complete();
            },
            error: (_error) => {},
          });
      }, StringConstants.FILE_READ_DELAY);
    });
  }

  public callFileStatus(): Observable<any> {
    const self = this;
    const fileUploadStatus: any = {};
    fileUploadStatus.requestid = this.requestId;
    fileUploadStatus.status = StringConstants.FILE_UPLOAD_STATUS;
    fileUploadStatus.filename = this.transactionPayload.fileName;

    return new Observable((observer) => {
      self.remicService
        .upfRemicUploadStatus(fileUploadStatus)
        .pipe(delay(1000))
        .subscribe({
          next: (_data) => {
            observer.next(true);
            observer.complete();
          },
          error: (_error) => {},
        });
    });
  }

  public broadcastFileUploadFailUpdates(error: any): void {
    this.fileUploadFailSource.next(error);
  }
}
